export const LANGUAGE_OPTIONS = [
    { key: 'English', label: 'English'},
    { key: 'Spanish', label: 'Spanish'},
];

export default LANGUAGE_OPTIONS;



// WEBPACK FOOTER //
// ./app/torchmark/options/LANGUAGE_OPTIONS.js